<!-- print-ticket.component.html -->

<div class="card mb-4">
    <div class="card-body">
      <div class="mb-3 d-flex align-items-center justify-content-between">
        <div class="col-lg-4 offset-md-4">
          <div class="row">
            <h4 class="mb-2 fw-bolder align-items-center">View Job's Ticket</h4>
          </div>
        </div>
        <div class="mb-2 col-lg-3">
          <input type="text" placeholder="Search by Name, Ticket No, Ref No, or Job Name" 
                 class="form-control mb-3" [(ngModel)]="searchText" (input)="onSearch()">
        </div>
      </div>
  
      <button (click)="deleteSelectedEntries()" class="btn btn-outline-danger mb-3">
        <i class="feather icon-trash-2"></i>
      </button>
  
      <div class="table-responsive" style="max-height: 700px; overflow-y: auto;">
        <table class="table table-bordered red-border text-center">
          <thead>
            <tr>
              <th><input type="checkbox" id="selectAllCheckbox" (change)="selectAllChanged($event)"></th>
              <th (click)="sortByColumn('ticketno')">Ticket No
                <i class="feather icon-arrow-up" *ngIf="sortColumn === 'ticketno' && sortDirection === 'asc'"></i>
                <i class="feather icon-arrow-down" *ngIf="sortColumn === 'ticketno' && sortDirection === 'desc'"></i>
              </th>
              <th (click)="sortByColumn('refNo')">Ref No
                <i class="feather icon-arrow-up" *ngIf="sortColumn === 'refNo' && sortDirection === 'asc'"></i>
                <i class="feather icon-arrow-down" *ngIf="sortColumn === 'refNo' && sortDirection === 'desc'"></i>
              </th>
              <th (click)="sortByColumn('poNo')">P.O No.
                <i class="feather icon-arrow-up" *ngIf="sortColumn === 'poNo' && sortDirection === 'asc'"></i>
                <i class="feather icon-arrow-down" *ngIf="sortColumn === 'poNo' && sortDirection === 'desc'"></i>
              </th>
              <th (click)="sortByColumn('clientName')">Customer
                <i class="feather icon-arrow-up" *ngIf="sortColumn === 'clientName' && sortDirection === 'asc'"></i>
                <i class="feather icon-arrow-down" *ngIf="sortColumn === 'clientName' && sortDirection === 'desc'"></i>
              </th>
              <th (click)="sortByColumn('jobName')">Job Name
                <i class="feather icon-arrow-up" *ngIf="sortColumn === 'jobName' && sortDirection === 'asc'"></i>
                <i class="feather icon-arrow-down" *ngIf="sortColumn === 'jobName' && sortDirection === 'desc'"></i>
              </th>
              <th (click)="sortByColumn('jobType')">Job Type
                <i class="feather icon-arrow-up" *ngIf="sortColumn === 'jobType' && sortDirection === 'asc'"></i>
                <i class="feather icon-arrow-down" *ngIf="sortColumn === 'jobType' && sortDirection === 'desc'"></i>
              </th>
              <th (click)="sortByColumn('orderKgs')">Quantity Kgs
                <i class="feather icon-arrow-up" *ngIf="sortColumn === 'orderKgs' && sortDirection === 'asc'"></i>
                <i class="feather icon-arrow-down" *ngIf="sortColumn === 'orderKgs' && sortDirection === 'desc'"></i>
              </th>
              <th>Print Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let order of paginatedOrderList">
              <td><input type="checkbox" class="rowCheckbox" [attr.data-id]="order._id" [(ngModel)]="order.selected"></td>
              <td>{{ order.ticketno }}</td>
              <td>{{ order.refNo }}</td>
              <td>{{ order.poNo }}</td>
              <td>{{ order.clientName }}</td>
              <td>{{ order.jobName }}</td>
              <td>{{ order.jobType }}</td>
              <td>{{ order.orderKgs | number:'1.2-2':'en-US'}}</td>
              <td>
                <button type="button" (click)="print(order)">
                  <i class="feather icon-printer"></i> Preview
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
  
      <!-- <div class="datatable-footer-inner selected-count d-flex justify-content-between">
        <div class="page-count mt-3">
          <span class="font-weight-bold">{{ calculateRangeStart() }} - {{ calculateRangeEnd() }} of {{ filteredOrderList.length }} total</span>
        </div>
        
        <div class="pagination mt-3 d-flex justify-content-center">
          <a class="pagination-btn pt-2" (click)="onPageChange(currentPage - 1)" [ngClass]="{'disabled': currentPage === 1}">
            <i class="feather icon-chevrons-left"></i>
          </a>
          <a *ngFor="let page of getNumberRange(getTotalPages())" 
             class="pagination-circle" 
             [class.active]="currentPage === page" 
             (click)="onPageChange(page)">
            {{ page }}
          </a>
          <a class="pagination-btn pt-2" (click)="onPageChange(currentPage + 1)" [ngClass]="{'disabled': currentPage === getTotalPages()}">
            <i class="feather icon-chevrons-right"></i>
          </a>
        </div>
    </div> -->

    <!-- <div class="datatable-footer-inner selected-count d-flex justify-content-between">
      <div class="page-count mt-3">
        <span class="font-weight-bold">{{ calculateRangeStart() }} - {{ calculateRangeEnd() }} of {{ filteredOrderList.length }} total</span>
      </div>
      
      <div class="pagination mt-3 d-flex justify-content-center">
        <a 
          class="pagination-btn pt-2" 
          (click)="onPageChange(currentPage - 1)" 
          [ngClass]="{'disabled': currentPage === 1}">
          <i class="feather icon-chevrons-left"></i>
        </a>
    
      
        <a *ngFor="let page of visiblePageRange" 
           class="pagination-circle" 
           [class.active]="currentPage === page" 
           (click)="onPageChange(page)">
          {{ page }}
        </a>
    
        <a 
          class="pagination-btn pt-2" 
          (click)="onPageChange(currentPage + 1)" 
          [ngClass]="{'disabled': currentPage === getTotalPages()}">
          <i class="feather icon-chevrons-right"></i>
        </a>
      </div>
    </div> -->

    <!-- <div class="datatable-footer-inner selected-count d-flex justify-content-between">
  <div class="page-count mt-3">
    <span class="font-weight-bold">{{ calculateRangeStart() }} - {{ calculateRangeEnd() }} of {{ filteredOrderList.length }} total</span>
  </div>
  
  <div class="pagination mt-3 d-flex justify-content-center">
   
    <a 
      class="pagination-btn pt-2" 
      (click)="onPageChange(currentPage - 1)" 
      [ngClass]="{'disabled': currentPage === 1}">
      <i class="feather icon-chevrons-left"></i>
    </a>

   
    <a *ngFor="let page of visiblePageRange" 
       class="pagination-circle" 
       [class.active]="currentPage === page" 
       (click)="onPageChange(page)">
      {{ page }}
    </a>

   
    <a 
      class="pagination-btn pt-2" 
      (click)="onPageChange(currentPage + 1)" 
      [ngClass]="{'disabled': currentPage === getTotalPages()}">
      <i class="feather icon-chevrons-right"></i>
    </a>
  </div>
</div> -->


<div class="datatable-footer-inner selected-count d-flex justify-content-between">
  <div class="page-count mt-3">
    <span class="font-weight-bold">
      {{ calculateRangeStart() }} - {{ calculateRangeEnd() }} of {{ filteredOrderList.length }} total
    </span>
  </div>

  <div class="pagination mt-3 d-flex justify-content-center">
    <!-- Previous page arrow -->
    <a 
      class="pagination-btn pt-2" 
      (click)="onPageChange(currentPage - 1)" 
      [ngClass]="{'disabled': currentPage === 1}">
      <i class="feather icon-chevrons-left"></i>
    </a>

    <!-- Current page number between arrows -->
    <span class="pagination-page-number">
      {{ currentPage }}
    </span>

    <!-- Next page arrow -->
    <a 
      class="pagination-btn pt-2" 
      (click)="onPageChange(currentPage + 1)" 
      [ngClass]="{'disabled': currentPage === getTotalPages()}">
      <i class="feather icon-chevrons-right"></i>
    </a>
  </div>
</div>


    
  </div>
  